import {AGENT, BROKER, SELLER, TRANSACTION_COORDINATOR} from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuAccountTypeAppResource';
import {AppResourceSearch, ApiFilter} from '@sellers-shield-home-protection/ss-core-js';
import UserAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/UserAppResource';
import {useAuthStore} from '@store';

export const isAgent = (user) => {
    return user?.accountTypeId === AGENT;
};

export const isSeller = (user) => {
    return user?.accountTypeId === SELLER;
};

export const isBroker = (user) => {
    return user?.accountTypeId === BROKER;
};

export const isTC = (user) => {
    return user?.accountTypeId === TRANSACTION_COORDINATOR;
}
export const isBrokerOwner = (user) => {
    return user?.isBrokerOwner;
}

export const isLinkedToCompany = (user) => {
    return !!user?.broker;
}

export const isMigrated = (user) => {
    return !!user?.oldMigratedId;
}

export const companyName = (user) => {
    return user?.broker && user?.broker?.companyName;
}

export const fetchUserState = async (user) => {
    const searchData = {
        filter: new ApiFilter({
            params: {
                id: user?.stateId,
            },
        }),
    };

    let luStateAppResourceSearch = new AppResourceSearch('lu-state');
    await luStateAppResourceSearch.setSearchData(searchData);
    await luStateAppResourceSearch.search();

    return luStateAppResourceSearch.appResourceCollection.getFirst();
};

export const fetchUser = async (uuid, include = []) => {
    let userAppResource = new UserAppResource({uuid}),
        gotResponseOk = await userAppResource.find(include);
        console.log('user.js fetchUser() found a user', gotResponseOk);

    if (!gotResponseOk || !userAppResource.exists) {
        userAppResource = new UserAppResource({uuid});
    }

    return userAppResource;
};

export const fullName = (user) => {
    return `${user?.firstName} ${user?.lastName}`;
}

export const initials = (user) => {
    return `${user?.firstName[0]}${user?.lastName[0]}`
}

export const refreshUserData = async (uuid = null, force = false, commitAsLogged = false) => {
    const storeAuth = useAuthStore();

    let loggedIn = true;
    try {
        let user = (force ? null : storeAuth.me) || {};
        force = Boolean(uuid || user.uuid || user._uuid) && (user.uuid !== uuid || user._uuid !== uuid || !user.exists);

        if (force) {
            user = await fetchUser(uuid || user.uuid || user._uuid, [
                'accountType',
                'state',
                'emailStatus',
                'avatarFile',
                'companyLogoFile',
                'additionalEmails',
                'broker',
                'seller',
                'licenses',
                'licenses.state',
                'nrds',
                'nrds.state',
            ]);
            user.uuid = uuid || user.uuid;

            if (!commitAsLogged) {
                return loggedIn ? user : {};
            }

            loggedIn = !!user.uuid && !!user.exists;
            console.log('user.js refreshUserData - called fetchUser, about to SET_ME()', loggedIn);
            storeAuth.SET_ME(loggedIn ? user : {});
        }

    } catch (error) {
        loggedIn = false;
        console.log(error);
    }

    return commitAsLogged ? loggedIn : {};
};
